import { Plus, Search } from 'lucide-react';
import { useSupport } from '../../../../../../../context/support/SupportContext';

const TicketListHeader = () => {
  const { ticketSearchTerm, setTicketSearchTerm, handleOpenNewTicket } = useSupport();

  return (
    <div className="p-4 bg-white border-b border-gray-200 space-y-3">
      <div className="flex items-center justify-between">
        <h2 className="text-xs font-bold text-gray-500 uppercase tracking-wider">Tickets</h2>
        <button
          onClick={handleOpenNewTicket}
          className="p-1.5 bg-[#067978] text-white rounded-lg hover:bg-teal-700 transition-colors flex items-center gap-1 text-xs font-bold px-3 shadow-sm cursor-pointer"
        >
          <Plus size={16} />
          <span>Raise Ticket</span>
        </button>
      </div>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={14} />
        <input
          type="text"
          placeholder="Search tickets..."
          value={ticketSearchTerm}
          onChange={(e) => setTicketSearchTerm(e.target.value)}
          className="w-full pl-9 pr-3 py-2 bg-gray-100 border-none rounded-lg text-sm outline-none focus:ring-1 focus:ring-[#067978]/30"
        />
      </div>
    </div>
  );
};

export default TicketListHeader;
